<template>
  <a :href="`/storage/${file}`" data-lity>
    <img :src="sourcePath" class="img-thumbnail"
      draggable="true"
      @dragstart="$emit('startDrag', $event)"
      @dragend="$emit('endDrag', $event)"
    >
    <p v-if="description">{{ description }}</p>
  </a>
</template>

<script>
  export default {
    props: ['file', 'description'],
    data() {
      return {
      }
    },
    computed: {
      sourcePath() {
        if (this.file.match(/\.(jpeg|jpg|gif|png)$/) !== null) {
          return `/storage/${this.file}`
        }

        if (this.file.match(/\.(mp4)$/) !== null) {
          return '/img/video-thumb.jpg'
        }

        return '/img/document-thumb.jpg'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/trials/GalleryThumb.vue